/* iter-compliance-cal-p2 — Health pill for the admin Hub header.
 * Polls /api/admin/compliance-calendar/health every 5 minutes.
 * Green when nothing is due within 30 days; Amber when 8-30d items exist;
 * Red when there are overdue items or anything due within 7 days.
 */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { CalendarClock } from 'lucide-react';

const API = (process.env.REACT_APP_BACKEND_URL || '') + '/api';
const http = axios.create({ baseURL: API, withCredentials: true });

const TONE_STYLES = {
  red:   'border-red-500/60 bg-red-500/15 text-red-800 dark:text-red-200',
  amber: 'border-amber-500/60 bg-amber-500/15 text-amber-800 dark:text-amber-200',
  green: 'border-emerald-500/40 bg-emerald-500/10 text-emerald-800 dark:text-emerald-200',
};

const DOT_STYLES = {
  red:   'bg-red-600 animate-pulse',
  amber: 'bg-amber-500',
  green: 'bg-emerald-500',
};

export default function ComplianceHealthPill() {
  const [health, setHealth] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const r = await http.get('/admin/compliance-calendar/health');
        if (!cancelled) setHealth(r.data.health);
      } catch (e) {
        // Silent — admin may not be authed yet or endpoint disabled.
        if (!cancelled) setHealth(null);
      }
    };
    load();
    const t = setInterval(load, 5 * 60 * 1000);   // 5 min
    return () => { cancelled = true; clearInterval(t); };
  }, []);

  if (!health) return null;
  const tone = TONE_STYLES[health.status] || TONE_STYLES.green;
  const dot  = DOT_STYLES[health.status]  || DOT_STYLES.green;

  return (
    <Link to="/admin/finance"
          state={{ jumpTo: 'tax-center', tab: 'calendar' }}
          data-testid="compliance-health-pill"
          title={`Compliance Calendar — ${health.message}`}
          className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-1 text-[11px] font-semibold transition ${tone}`}>
      <CalendarClock className="h-3 w-3" />
      <span className={`inline-block h-1.5 w-1.5 rounded-full ${dot}`} />
      <span className="hidden sm:inline">{health.message}</span>
      <span className="sm:hidden">
        {health.overdue > 0 ? `${health.overdue} ovr` :
          health.urgent > 0 ? `${health.urgent} urgent` :
          health.soon > 0 ? `${health.soon} soon` : 'OK'}
      </span>
    </Link>
  );
}
